<!-- ============================================================== -->
<!-- <Html> - Página principal -->
<!-- ============================================================== -->
<app-spinner></app-spinner>
<app-view-succes></app-view-succes>

<div>
    <div class="wrapper">
        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
        <div>
            <!-- Importa Header -->
            <app-topbar></app-topbar>

            <!-- Importa Barra Navegación (Izquierda) -->
            <app-leftpanel></app-leftpanel>

            <!-- ============================================================== -->
            <!-- Page wrapper  -->
            <!-- ============================================================== -->
            <div class="content-wrapper">
                <!-- Importa Miga de Pan -->
                <app-headercontent></app-headercontent>

                <!-- ============================================================== -->
                <!-- Start Page Content -->
                <!-- ============================================================== -->
                <section>
                    <div class="container" style="margin: auto">
                        <!-- Tag que indica en dónde cargar los componentes a partir del ruteo -->
                        <router-outlet></router-outlet>
                    </div>
                </section>
                <!-- ============================================================== -->
                <!-- End PAge Content -->
                <!-- ============================================================== -->
            </div>
        </div>
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
        <!-- Plantilla sin sesión -->
        <!-- ============================================================== -->
        <ng-template #elseBlock>
            <div class="content-wrapper">
                <section>
                    <div>
                        <router-outlet></router-outlet>
                    </div>
                </section>
            </div>
        </ng-template>
        <!-- ============================================================== -->
        <!-- End Plantilla sin sesión  -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
        <!-- footer -->
        <!-- ============================================================== -->
        <app-footer></app-footer>
        <!-- ============================================================== -->
        <!-- End footer -->
        <!-- ============================================================== -->
    </div>
</div>
